<dx-data-grid
  id="userSecurityGrid"
  [dataSource]="userSecurityGridItems"
  keyExpr="key"
  [showBorders]="false"
  (onCellClick)="onCellClick($event)"
>
  <dxo-paging [enabled]="false"></dxo-paging>
  <dxo-editing mode="batch" [allowUpdating]="true"> </dxo-editing>
  <dxi-column
    dataField="label"
    caption=""
    [allowEditing]="false"
    [allowReordering]="false"
    [allowSorting]="false"
    [width]="145"
  ></dxi-column>
  <dxi-column dataField="canRead" dataType="boolean" [allowReordering]="false" [allowSorting]="false"></dxi-column>
  <dxi-column dataField="canEdit" dataType="boolean" [allowReordering]="false" [allowSorting]="false"></dxi-column>
  <dxi-column dataField="canDelete" dataType="boolean" [allowReordering]="false" [allowSorting]="false"></dxi-column>
  <dxi-column
    dataField="isNotUserGroup"
    groupCellTemplate="groupCellTemplate"
    [groupIndex]="0"
    [visible]="false"
  ></dxi-column>
  <div *dxTemplate="let data of 'groupCellTemplate'" [ngClass]="!data.value && 'groupCellHidden'"></div>
  <dxo-group-panel [visible]="false"></dxo-group-panel>
  <dxo-grouping [allowCollapsing]="false"></dxo-grouping>
</dx-data-grid>
